import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import AnimatedBackground from '../components/AnimatedBackground';
import { fireEvent } from '../utils/funnelEvents';
import ArticleStructuredData from '../components/ArticleStructuredData';
import VerticalHeader from '../components/VerticalHeader';

import RealEstateHero from './real-estate/RealEstateHero';
import Workflow from './real-estate/Workflow';
import PainPoints from './real-estate/PainPoints';
import DocumentTypes from './real-estate/DocumentTypes';
import DotloopIntegration from './real-estate/DotloopIntegration';
import RelatedReading from './real-estate/RelatedReading';
import VerticalPricing from './shared/VerticalPricing';
import RealEstateFAQ from './real-estate/RealEstateFAQ';
import VerticalContact from './shared/VerticalContact';
import ResearchInviteCard from '../components/research/ResearchInviteCard';

const PAGE_TITLE = 'AI File Organizer for Real Estate (dotloop, MLS, Transactions) | Sortio';
const PAGE_DESCRIPTION =
  'Sortio organizes per-property folders for real estate agents, transaction coordinators, and brokerages. Auto-routes contracts, disclosures, MLS photos, drone shots, inspection reports, and closing docs. dotloop integration shipping. Runs on Mac and Windows.';

const NAV = [
  { href: '#workflow', label: 'How it works' },
  { href: '#document-types', label: 'Document types' },
  { href: '#dotloop', label: 'dotloop' },
  { href: '#pricing', label: 'Pricing' },
];

const RealEstatePage = () => {
  useEffect(() => {
    fireEvent('team_page_view', { vertical: 'real-estate' });
  }, []);

  return (
    <>
      <Helmet>
        <title>{PAGE_TITLE}</title>
        <meta name="description" content={PAGE_DESCRIPTION} />
        <meta
          name="keywords"
          content="ai file organizer real estate, dotloop file organization, transaction coordinator software, per-property folder organization, MLS photo rename, real estate document management, closing docs organizer, brokerage file management"
        />
        <meta property="og:title" content={PAGE_TITLE} />
        <meta property="og:description" content={PAGE_DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://www.getsortio.com/for-real-estate" />
        <link rel="canonical" href="https://www.getsortio.com/for-real-estate" />
      </Helmet>
      <ArticleStructuredData
        title={PAGE_TITLE}
        description={PAGE_DESCRIPTION}
        datePublished="2026-05-14T00:00:00.000Z"
        dateModified="2026-05-14T00:00:00.000Z"
        authorName="Sortio Team"
      />

      <VerticalHeader verticalLabel="Real Estate" navItems={NAV} />
      <RealEstateHero />

      <div className="relative">
        <AnimatedBackground variant="business" />
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
          <Workflow />
          <PainPoints />
          <DocumentTypes />
          <DotloopIntegration />
          <RelatedReading />
          <VerticalPricing
            verticalLabel="Real Estate"
            description="Solo agents and small brokerages start with Pro. Transaction coordinator teams and larger brokerages graduate to Team for shared rules across agents."
            proDescription="For agents, TCs, and small brokerages"
            proFeatureLabel="Per-property folder routing"
          />
          <RealEstateFAQ />
          <ResearchInviteCard vertical="real-estate" />
          <VerticalContact
            waitlistType="real-estate"
            body="Tell us about your transactions and we will show you Sortio working with a sample closing folder."
            orgLabel="Brokerage Name"
            orgPlaceholder="Acme Real Estate"
            sizeLabel="Team Size"
          />
        </div>
      </div>
    </>
  );
};

export default RealEstatePage;
